<template>
	<div>
		
		<div class="row">
			<div class="columns large-12">
				<h5>{{setting.title}}</h5>	
			</div>
		</div>

		<div class="row" v-for="eachInput in setting.inputs" v-if="paymentSettings[eachInput.setting]!=''">
			<div class=" columns">
				<h6 class="mbn">{{eachInput.label}}
					&nbsp;
					<span v-if="eachInput.input_type == 'radio'">
						<i v-if="paymentSettings[eachInput.setting]=='true'" class="fa fa-lg fa-check-circle-o"></i>
						<i v-else class="fa fa-lg fa-times"></i>
					</span>
				</h6>
			</div>
			<div class="columns">
				<div v-if="eachInput.input_type != 'radio'">
					<p class="mbn smaller">
						{{paymentSettings[eachInput.setting]}}
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
	name: 'AlternativePayment',
	data () {
		return  {

		}
	},
	props: {
		'setting' : {
			type: Object,
			required: true
		}
	},
	computed : {
		...mapGetters([
			'paymentSettings'
		]),
	}

}
	
</script>



<style scoped>
	h5 {
		font-size: 1rem;
		font-weight: 600;
		color: #4D5C77;

	}


	h6 {
		font-size: 0.9rem;
		color: #4D5C77;
	}

</style>